//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "table-with-extra-header",
  props: ['title','headers', 'items', "height", "showFooter",'itemCount','hideExtraHeader'],
  data() {
    return {
      mobileView: false,
      mobileBreakpoint: 600,
      pageNumber: 1,
    }
  },
  mounted() {
    this.updateMobileView();
    window.addEventListener('resize', this.updateMobileView);
  },
  unmounted() {
    window.removeEventListener('resize', this.updateMobileView)
  },
  methods: {
    getItemProperties(item) {
      let results = []
      const currentItemEntries = Object.entries(item)
      this.headers.forEach(tHead=>{
        currentItemEntries.forEach(arr=>{
          if(arr.includes(tHead.value)) {
            results.push(arr[0])
          }
        })
        if(!results.includes(tHead.value)) results.push(tHead.value)
      })
      return results
    },
    getHeaderTextForItemProp(itemProp) {
      const headName = this.headers.find(head=>head.value === itemProp).text
      if(headName !== null && headName !== undefined) {
        return headName;
      }
      return itemProp;
    },
    updateMobileView() {
      if(this.$refs.compBody) {
        if(this.$refs.compBody.clientWidth < this.mobileBreakpoint && !this.mobileView) {
          this.mobileView = true;
        }
        else if(this.$refs.compBody.clientWidth >= this.mobileBreakpoint && this.mobileView) {
          this.mobileView = false;
        }
        if(this.$refs.compBody.clientWidth === 0 && window.innerWidth > this.mobileBreakpoint && this.tableIsInDialog) {
          this.mobileView = false;
        }
      }
    },
    changePage(direction) {
      if(this.pageNumber+direction <=0 || this.pageNumber+direction > this.numberOfPages) return;
      this.pageNumber+= direction;
      this.$emit('changePage', this.pageNumber)
    }
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.itemCount/10)
    }
  }
}
